'use strict';
import { App } from "./controllers/App";
window.InstanceCollection = window.InstanceCollection || {};

const $jq = window.$jq || jQuery.noConflict();
if (!$jq.ADAC) {
	$jq.ADAC = {};
}

window.$ = jQuery;
// Create the defaults once
const pluginName = 'FuelPricesUserFeedback',
	namespace = 'ADAC', fqname = `${namespace}_${pluginName}`;

// The actual plugin constructor
$jq.ADAC[pluginName] = function (element, options, loader) {
	this.tid = options.app.tid;
	this.element = element;
	this.loader = loader;
	this.options = options;
	this.options.$jq = $jq;
	this.$ctx = this.options.$ctx;
	this._name = pluginName;

	// declare public methods
	window.InstanceCollection[pluginName] = this;
	this.application = new App(this.element, this.options, this.loader);
	this.application.start();
};

$jq.fn[fqname] = function (options, loader) {
	return this.each(function () {
		if (!$jq.data(this, fqname)) {
			$jq.data(this, fqname,
				new $jq.ADAC[pluginName](this, options, loader));
		}
	});
};

/*! Version: 3.192.0.113577; Commit: 442453452006a0ec7a5b35b86c8085cc4ad8b8fb */
